import { ExotelReduceActions } from "./actions";

function reduceApiKeyUpdate(state, action) {
  const trimmedApiKey = action.payload.apiKey.trim();

  const shouldShowError = trimmedApiKey === "" && !state.errors.apiKey;
  const apiKeyError = shouldShowError ? "API Key is required" : null;

  return {
    ...state,
    apiKey: trimmedApiKey,
    errors: {
      ...state.errors,
      apiKey: apiKeyError,
    },
  };
}

function reduceAPITokenUpdate(state, action) {
  const trimmedAPIToken = action.payload.apiToken.trim();

  const shouldShowError = trimmedAPIToken === "" && !state.errors.apiToken;
  const apiTokenError = shouldShowError ? "API Token is required" : null;

  return {
    ...state,
    apiToken: trimmedAPIToken,
    errors: {
      ...state.errors,
      apiToken: apiTokenError,
    },
  };
}

function reduceAccountSIDUpdate(state, action) {
  const trimmedAccountSID = action.payload.accountSid;

  const shouldShowError = trimmedAccountSID === "" && !state.errors.accountSid;
  const accountSIDError = shouldShowError ? "Account SID is required" : null;

  return {
    ...state,
    accountSid: trimmedAccountSID,
    errors: {
      ...state.errors,
      accountSid: accountSIDError,
    },
  };
}

function reduceSubdomainUpdate(state, action) {
  const trimmedSubdomain = action.payload.subdomain.trim();

  const shouldShowError =
    trimmedSubdomain === "" && !state.errors.trimmedSubdomain;
  const subdomainError = shouldShowError ? "Sub Domain is required" : null;

  return {
    ...state,
    subdomain: trimmedSubdomain,
    errors: {
      ...state.errors,
      subdomain: subdomainError,
    },
  };
}

function reduceVoiceBotAppIdUpdate(state, action) {
  const trimmedVoiceBotAppId = action.payload.voiceBotAppId.trim();

  const shouldShowError =
    trimmedVoiceBotAppId === "" && !state.errors.trimmedVoiceBotAppId;
  const voiceBotAppIdError = shouldShowError
    ? "Voicebot App Id is required"
    : null;

  return {
    ...state,
    voiceBotAppId: trimmedVoiceBotAppId,
    errors: {
      ...state.errors,
      voiceBotAppId: voiceBotAppIdError,
    },
  };
}

function reducePhoneNumberUpdate(state, action) {
  const trimmedPhoneNumber = action.payload.phoneNumber.trim();
  const phoneNumberIdx = action.payload.phoneNumberIdx;

  const shouldShowError =
    trimmedPhoneNumber === "" && !state.errors.trimmedPhoneNumber;
  const phoneNumberError = shouldShowError ? "Phone Number is required" : null;

  return {
    ...state,
    phoneNumbers: state.phoneNumbers.toSpliced(
      phoneNumberIdx,
      1,
      trimmedPhoneNumber
    ),
    errors: {
      ...state.errors,
      phoneNumbers: {
        ...state.errors.phoneNumbers,
        [phoneNumberIdx]: phoneNumberError,
      },
    },
  };
}

function reduceRemovePhoneNumber(state, action) {
  const phoneNumberIdx = action.payload.phoneNumberIdx;

  return {
    ...state,
    phoneNumbers: state.phoneNumbers.toSpliced(phoneNumberIdx, 1),
    errors: {
      ...state.errors,
      phoneNumbers: {
        ...state.errors.phoneNumbers,
        [phoneNumberIdx]: null,
      },
    },
  };
}

export default function reduceExotelSettings(state, action) {
  switch (action.type) {
    case ExotelReduceActions.UPDATE_API_KEY:
      return reduceApiKeyUpdate(state, action);
    case ExotelReduceActions.UPDATE_API_TOKEN:
      return reduceAPITokenUpdate(state, action);
    case ExotelReduceActions.UPDATE_ACCOUNT_SID:
      return reduceAccountSIDUpdate(state, action);
    case ExotelReduceActions.UPDATE_SUBDOMAIN:
      return reduceSubdomainUpdate(state, action);
    case ExotelReduceActions.UPDATE_VOICE_BOT_APP_ID:
      return reduceVoiceBotAppIdUpdate(state, action);
    case ExotelReduceActions.ADD_PHONE_NUMBER:
      return {
        ...state,
        phoneNumbers: [...state.phoneNumbers, ""],
      };
    case ExotelReduceActions.UPDATE_PHONE_NUMBER:
      return reducePhoneNumberUpdate(state, action);
    case ExotelReduceActions.REMOVE_PHONE_NUMBER:
      return reduceRemovePhoneNumber(state, action);
    case ExotelReduceActions.SET_STATE:
      return action.payload;
    default:
      return state;
  }
}
